export function LambdaSettings() {
  this.Lambdas = [ "receiver", "filter", "sender", "restAPI", "downloadobjects", "uploadobjects", "arupCompute", "proximity"]
}